import { render, staticRenderFns } from "./ReschedulingWizard.vue?vue&type=template&id=198624c0&scoped=true"
import script from "./ReschedulingWizard.vue?vue&type=script&lang=js"
export * from "./ReschedulingWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198624c0",
  null
  
)

export default component.exports